import { render, staticRenderFns } from "./cates.vue?vue&type=template&id=49e84b84"
import script from "./cates.vue?vue&type=script&lang=js"
export * from "./cates.vue?vue&type=script&lang=js"
import style0 from "./cates.vue?vue&type=style&index=0&id=49e84b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports